import { render, staticRenderFns } from "./AcademyDeleteDialog.vue?vue&type=template&id=f47202d2&"
import script from "./AcademyDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./AcademyDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports